<app-mobile-collapsible-section
  [title]="personaName"
  [showOnDesktop]="true"
  [initialExpanded]="initialExpanded()"
>
  <div collapsibleBody class="tw-flex tw-flex-col">
    <select-input
      [control]="interactsWithControl"
      [label]="'Can interact with'"
      [placeholder]="'Can interact with'"
      [id]="'handshake-interacts-' + (persona().id ?? 0)"
      key="name"
      [valueName]="'id'"
      [values]="interactOptions()"
      [isSingleSelect]="false"
      [enableSearch]="false"
      [clear]="false"
      [clearAll]="false"
    ></select-input>
  </div>
</app-mobile-collapsible-section>
